import axios from "axios";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { v1 as uuid } from "uuid";

function Adminevent(props) {
  const [data, setdata] = useState([]);
  const apiURL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    getusers();
  }, []);

  const getusers = () => {
    try {
      axios
        .get(`/api/getevent`)
        .then(function (response) {
          if (response.status === 200) {
            console.log(response.data);
            //  localStorage.setItem("userdata",JSON.stringify(response.data.userdata));
            setdata(response.data.event);
            return;
          } else {
            //alert("Can't able to fetch ");
            //setdatacondition(true);
            return;
          }
        })
        .catch(function (error) {
          // setdatacondition(true);
          console.log(error.message.data);
          //alert("Can't able to fetch ");
          return;
        });
    } catch (error) {
      console.warn(error);
      alert("Can't able  to fetch ");
      // setdatacondition(true);
      return error;
    }
  };

  const postdeleteimage = async (data) => {
    try {
      const config = {
        url: "/deleteevent/" + data._id,
        method: "post",
        baseURL: "/api",
        headers: { "event-type": "multipart/form-data" },

        //responseType:"application/json"
      };
      let res = await axios(config);
      if (res.status === 200) {
        console.log(res.data);
        alert("event deleted successfully");
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
    }
  };
  async function create(data) {
    try {
      const id = uuid();
      const config = {
        url: "/eventroomid",
        method: "post",
        baseURL: "/api",
        headers: { "event-type": "application/json" },
        data: { id: data._id, roomid: data._id },

        //responseType:"application/json"
      };
      let res = await axios(config);
      if (res.status === 200) {
        window.location.assign(`/room/${data._id}`);
        // console.log(res.data);
        // alert("event deleted successfully")
        // window.location.reload();
      }
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div style={{ background: "#fff" }}>
      <h2 style={{ color: "#01a695", textAlign: "center" }}> event </h2>
      <Table responsive hover size="md">
        <thead>
          <tr>
            <th>S. no</th>
            <th>Image</th>
            <th> event title </th>
            <th> event time </th>
            <th> event amount </th>
            <th> event Content </th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((datas) => (
            <tr>
              <td>1</td>
              <td>
                {" "}
                <img
                  src={"http://bd.parnetslink.com/event/" + datas.eventimage}
                  height="100px"
                  width="100px"
                  style={{ borderRadius: "100%" }}
                />{" "}
              </td>
              <td>{datas.eventtitle}</td>
              <td>{datas.eventtime}</td>
              <td>{datas.eventamount}</td>
              <td>{datas.eventcontent}</td>
              <td>
                <button
                  className="btn btn-outline-success"
                  onClick={() => create(datas)}
                >
                  Create room
                </button>{" "}
                <button
                  className="btn btn-outline-danger"
                  onClick={() => postdeleteimage(datas)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
          {/* <tr>
                                    <td>DR David</td>
                                    <td><img src="" height /></td>                                                               
                                    <td><div className=""> <button className="btn btn-danger">Cancel</button> </div></td>
                                </tr> */}
        </tbody>
      </Table>
    </div>
  );
}

export default Adminevent;
